import React from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

import { makeBEM } from "utils";

import { NavigationItem } from "../navigation-items";

import "./index.scss";

export interface AppMenuItemProps extends NavigationItem {}

const bem = makeBEM("app-menu-item");

export const AppMenuItem: React.FC<AppMenuItemProps> = ({ label, exact, icon, to }) => {
  const resolvedPath = useResolvedPath(to);
  const match = useMatch({
    path: resolvedPath.pathname,
    end: exact,
  });
  const active = !!match;

  return (
    <li
      className={bem(null, {
        active,
      })}
    >
      <span className={bem("icon")}>{icon}</span>
      <span className={bem("label")}>
        <Link to={to}>{label}</Link>
      </span>
    </li>
  );
};
